import { pathOr } from 'ramda';
export var SelectedReasonIdSelector = function SelectedReasonIdSelector(state) {
  return pathOr(null, ['customercare', 'customer', 'selectedCustomer', 'eWallet', 'data', 'blocklistAllowlist', 'selectedReasonId'], state);
};